const c = {
  name: "Dns",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9,15H6v10h3c2.8,0,5-2.2,5-5S11.8,15,9,15z M9,23H8v-6h1c1.7,0,3,1.3,3,3C12,21.7,10.7,23,9,23z"/>
		<path class="st0" d="M18.6,15H16v10h2v-6.8l3.4,6.8H24V15h-2v6.8L18.6,15z"/>
		<path class="st0" d="M29,17c-0.5,0-1,0.5-1,1c0,0.5,0.5,1,1,1h2c1.7,0,3,1.3,3,3s-1.3,3-3,3h-2c-1.7,0-3-1.3-3-3h2
			c0,0.5,0.5,1,1,1h2c0.5,0,1-0.5,1-1c0-0.5-0.5-1-1-1h-2c-1.7,0-3-1.3-3-3s1.3-3,3-3h2c1.7,0,3,1.3,3,3h-2c0-0.5-0.5-1-1-1H29z"/>
		<path class="st0" d="M19.9,40C8.9,39.9,0,31,0,20C0,9,9,0,20,0c11,0,20,9,20,20c0,11-8.9,19.9-19.9,20c0,0-0.1,0-0.1,0L19.9,40
			C20,40,19.9,40,19.9,40z M2,20c0,3.3,0.9,6.4,2.4,9h31.2c1.5-2.6,2.4-5.7,2.4-9s-0.9-6.4-2.4-9H4.4C2.9,13.6,2,16.7,2,20z M5.8,31
			c2.1,2.8,5.1,4.9,8.4,6c-1.4-1.5-2.5-3.6-3.4-6H5.8z M12.9,31c0.8,1.9,1.7,3.5,2.8,4.7c1.1,1.2,2.2,1.9,3.3,2.2V31H12.9z
			 M24.3,35.7c1.1-1.2,2-2.8,2.8-4.7H21v6.9C22.1,37.6,23.3,36.9,24.3,35.7z M29.2,31c-0.9,2.4-2,4.5-3.4,6c3.4-1.2,6.3-3.3,8.4-6
			H29.2z M10.8,9c0.4-1,0.8-1.9,1.2-2.8c0.3-0.5,0.6-1,0.9-1.5C13,4.4,13.2,4.2,13.4,4l0,0c0.1-0.2,0.3-0.4,0.5-0.7
			C14,3.2,14.1,3.1,14.2,3c-3.4,1.2-6.3,3.3-8.4,6H10.8z M26.2,7.1L26.2,7.1L26.2,7.1c-0.3-0.5-0.5-0.9-0.8-1.3l0,0l0,0
			c-0.1-0.2-0.3-0.4-0.4-0.6c-0.2-0.2-0.3-0.4-0.4-0.5l0,0l0,0c-0.1-0.2-0.3-0.3-0.4-0.5l0,0l0,0C24.1,4,24,3.9,23.9,3.8l0,0l0,0
			c-0.2-0.2-0.4-0.3-0.5-0.5l0,0l0,0c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.3-0.6-0.4l0,0l0,0c-0.1-0.1-0.2-0.1-0.2-0.1l-0.1,0
			l-0.1,0c0,0,0,0-0.1,0l0,0l0,0c-0.1-0.1-0.2-0.1-0.2-0.1l0,0l0,0c-0.1-0.1-0.2-0.1-0.3-0.1l0,0l0,0c-0.1,0-0.2,0-0.2-0.1V9h6.1
			C26.8,8.3,26.5,7.7,26.2,7.1z M19,2.1c-0.1,0-0.2,0-0.2,0.1l0,0l0,0c-0.1,0-0.2,0.1-0.3,0.1l0,0l0,0c0,0-0.1,0-0.2,0.1l0,0l0,0
			c0,0,0,0-0.1,0l-0.1,0l-0.1,0c0,0-0.1,0.1-0.2,0.1l0,0l0,0C17.3,2.8,17.2,3,17,3.1c-0.1,0.1-0.1,0.1-0.2,0.1l0,0l0,0
			c-0.2,0.1-0.4,0.3-0.5,0.5l0,0l0,0C16,3.9,15.9,4,15.9,4.1l0,0l0,0c-0.2,0.2-0.3,0.3-0.4,0.5l0,0l0,0c-0.1,0.1-0.2,0.3-0.4,0.5
			c-0.1,0.2-0.3,0.4-0.4,0.6l0,0l0,0c-0.3,0.4-0.5,0.8-0.8,1.3l0,0l0,0c-0.3,0.6-0.6,1.2-0.9,1.9H19V2.1z M34.2,9
			c-2.1-2.8-5.1-4.9-8.4-6c0.1,0.1,0.2,0.2,0.3,0.4c0.2,0.2,0.4,0.5,0.5,0.7l0,0c0.2,0.2,0.3,0.4,0.5,0.7c0.3,0.5,0.6,1,0.9,1.5
			C28.5,7.1,28.9,8,29.2,9H34.2z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Dns
};
